import React from 'react';
import { useTranslation } from 'react-i18next';
import Tag from '@components/ui/Tag.tsx';
import { ColorSchema, ColorVariant } from '@utils/types.ts';

/**
 * Dostupnost u dodavatele ze synchronizace e-shopu dodavatele (`availability` u dodavatele
 * v dlaždici i v detailu). Backend posílá null, když je údaj nezjištěný nebo starší než 48 h.
 * „Skladem" štítek nemá — jinak by ho měla skoro každá dlaždice.
 */
// Barevné schéma per stav: `Tag` dává error/info ve `light` bílý text na světlé podklady
// (nečitelné) a warning v `dark` tmavý text na tmavě oranžovou — proto ne jedno schéma pro všechny.
const availabilityTags: Record<string, { key: string; color: ColorVariant; colorSchema: ColorSchema }> = {
  LOW_STOCK: { key: 'productDetail.availability.LOW_STOCK', color: 'warning', colorSchema: 'light' },
  TEMPORARILY_UNAVAILABLE: { key: 'productDetail.availability.TEMPORARILY_UNAVAILABLE', color: 'info', colorSchema: 'dark' },
  UNAVAILABLE: { key: 'productDetail.availability.UNAVAILABLE', color: 'error', colorSchema: 'dark' },
};

interface SupplierAvailabilityTagProps {
  availability?: string | null;
}

const SupplierAvailabilityTag: React.FC<SupplierAvailabilityTagProps> = ({ availability }) => {
  const { t } = useTranslation('client');
  const tag = availability ? availabilityTags[availability] : undefined;
  if (!tag) return null;
  return <Tag text={t(tag.key)} color={tag.color} colorSchema={tag.colorSchema} componentState={'default'} size={'xs'} />;
};

export default SupplierAvailabilityTag;
